// export const IS_LOCALHOST =
//   ["localhost", "127.0.0.1", "192.168.1."].findIndex(x =>
//     window.location.hostname.startsWith(x)
//   ) !== -1;
// export const API_BASE_URL = IS_LOCALHOST
//   ? "//localhost:8000"
//   : "https://api.fretshare.com/";

export const DEV_MODE = process.env.NODE_ENV === "development";

export const API_BASE_URL = DEV_MODE
  ? "//localhost:8000"
  : "https://api.fretshare.com/";

export const API_TIMEOUT = DEV_MODE ? 10000 : 8000;

export const LOCALSTORAGE = {
  credentials: "_fretshare_creds"
};
